<template>
  <div id="contenedor-editar-usuario">
    <v-form
      v-model="formularioValido"
      ref="editarUsuario">
      <v-card>
        <v-card-title class="secondary--text">
          Editar usuario
          <v-spacer></v-spacer>
          <v-btn
            icon
            @click="cerrar">
            <v-icon class="secondary--text" large>highlight_off</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-row>
            <custom-text-field
              cols="12"
              v-model="usuario.correoElectronico"
              label="Correo"
              :rules="[mixReglas.requerido, mixReglas.email]">
            </custom-text-field>
            <custom-text-field
              cols="12"
              v-model="usuario.password"
              label="Password"
              >
            </custom-text-field>
            <custom-text-field
              cols="12"
              v-model="usuario.rePassword"
              label="Re-Password"
              >
            </custom-text-field>
          </v-row>
          <!-- Perfiles predeterminados -->
            <v-card style="border:1px solid #6A83B5;" flat class="rounded-lg ma-1">
              <v-card-title>Perfiles</v-card-title>
              <v-card-text>
                <v-select
                :items="getNamePerfilesList"
                v-model="seleccionadoPerfil"
                label="Seleccione perfil, para predefinir opciones..."
                @change="seleccionaPerfil(seleccionadoPerfil)"
                disabled>
                </v-select>

              <custom-autocomplete
                v-if="seleccionadoPerfil === 'Contratista'"
                cols="12"
                v-model="usuario.idContratista"
                label="Contratista"
                :items="getContratistas"
                itemText="nombreRazonSocial"
                itemValue="id"
                clearable
                disabled
                >
              </custom-autocomplete>
              <custom-autocomplete
                v-if="seleccionadoPerfil === 'Cliente'"
                cols="12"
                v-model="usuario.idCliente"
                label="Cliente"
                :items="getClientes"
                itemText="nombre"
                itemValue="id"
                clearable
                disabled
                >
              </custom-autocomplete>
            <custom-autocomplete
              v-if="seleccionadoPerfil === 'Responsable'"
              cols="12"
              v-model="usuario.idFuncionario"
              label="Responsable"
              :items="getFuncionarios"
              itemText="nombre"
              itemValue="id"
              clearable
              disabled
              >
            </custom-autocomplete>

              </v-card-text>
            </v-card>

            <!-- Roles / Scopes -->
              <v-card style="border: 1px solid #6A83B5;" flat class="rounded-lg ma-2">
                <v-card-title>Roles/Permisos
                  <!-- Botón para deseleccionar todos los scopes -->
                  <v-tooltip top color="verde2">
                    <template v-slot:activator="{on,attrs}">
                      <custom-button
                      tipo="formCancelar"
                      iconText="mdi-key-remove"
                      label=""
                      class="ml-4 pa-1"
                      tooltip="Deseleccionar permisos"
                      v-bind="attrs"
                      v-on="on"
                      @click="limpiarRoles"
                      >

                      </custom-button>
                  </template>
                  <span>Deseleccionar todos los permisos</span>
                  </v-tooltip>
                </v-card-title>
                <v-card-text>
                  <v-row
                    v-for="(item, i) in getRolesList"
                    :key="`rol-${item.rol}-${i}`"
                    align="center"
                    no-gutters>
                    <v-col cols="3">
                      <!-- Checkbox ROL  -->
                      <v-checkbox
                        :id="`rol-${item.rol}-${i}`"

                        v-model="item.scopes.ver"
                        :value="getRolesList[i].scopes.ver"
                        :label="item.rol"

                        @click="seleccionaRol(getRolesList[i].scopes,i)"
                        color="secondary"
                        hide-details
                        class="my-0 mx-2">
                      </v-checkbox>
                    </v-col>
                    <v-col
                      v-for="(scope, index) in Object.keys(item.scopes)"
                      :key="`rol-${item.rol}-${i}-scope-${scope}`"
                      cols="2">
                      <!-- Checkbox SCOPES-->
                      <v-checkbox
                        :id="`rol-${item.rol}-${i}-scope-${scope}`"
                        v-if=" index > 0 && item.rol!='Administración'"
                        v-model="item.scopes[scope]"
                        :value="getRolesList[i].scopes[index]"
                        :label="scope"
                        @click="seleccionaScope(`rol-${item.rol}-${i}-scope-${scope}`,
                        getRolesList[i].scopes[index])"
                        color="success"
                        hide-details
                        class="my-0 mx-2">
                      </v-checkbox>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>

        </v-card-text>
        <v-divider class="bkground" />
        <v-card-actions>
          <v-spacer></v-spacer>
          <custom-button
            @click="cerrar"
            tipo="formCancelar"
            label="Cancelar"
            class="mr-3">
          </custom-button>
          <custom-button
            @click="mixActualizarUsuario"
            tipo="formAceptar"
            label="Guardar"
            :disabled="!formularioValido || enviandoFormulario">
          </custom-button>
        </v-card-actions>
      </v-card>
    </v-form>
  </div>
</template>

<script>
import CustomTextField from '@/components/inputs/TextField.vue';
import CustomAutocomplete from '@/components/inputs/Autocomplete.vue';
import CustomButton from '@/components/buttons/Button.vue';
import mixCatalogoUsuarios from './mixCatalogoUsuarios';

export default {
  name: 'EditarUsuario',
  mixins: [mixCatalogoUsuarios],
  components: {
    CustomTextField,
    CustomAutocomplete,
    CustomButton,
  },
  props: {
    usuarioEditar: Object,
  },
  data() {
    return {
      formularioValido: false,
      enviandoFormulario: false,
      usuario: {
        // idCliente: 'a98aa86a-b3ff-41de-9a2b-c8c7d6f9be27',
        idCliente: this.usuarioEditar.cliente?.id || '',
        idContratista: this.usuarioEditar.contratista?.id || '',
        idFuncionario: this.usuarioEditar.funcionario?.id || '',
        correoElectronico: this.usuarioEditar.correoElectronico,
        avatarPublicKey: null,
        password: '',
        rePassword: '',
      },
      roles: this.usuarioEditar.roles,
      scopes: this.usuarioEditar.scopes,
      rolesScopes: [],
      seleccionadoPerfil: '',
    };
  },
  mounted() {
    this.marcaRolesEditar();
    this.seleccionarPerfilEditar();
  },
  methods: {
    seleccionarPerfilEditar() {
      if (this.usuario.idCliente !== '') {
        this.seleccionadoPerfil = 'Cliente';
      }
      if (this.usuario.idContratista !== '') {
        this.seleccionadoPerfil = 'Contratista';
      }
      if (this.usuario.idFuncionario !== '') {
        this.seleccionadoPerfil = 'Responsable';
      }
    },
    limpiarFormulario() {
      this.$refs.editarUsuario.reset();
    },
    cerrar() {
      this.limpiarFormulario();
      this.$emit('cerrar');
    },
  },
};
</script>

<style lang="scss">

</style>
